import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
    state:{


        //当前机构Code
        activeInstitutionCode: null,
        //当前机构的职工Code
        activeStaffCode: null,


        listMenuDTO:null,
        listMenuTop:null,
        listMenuLeft:null,
        //当前顶部导航的项
        activeMenuTop:null,

        tableHeight:200,

    },
    mutations: {

        update(state,[key,value]){
            state[key]=value;
        },

    },

})

export default store
